module.exports = __webpack_public_path__ + "static/media/lock.e580ac31.svg";